module.exports = __webpack_public_path__ + "img/材料力学1_5_4.49eff8e5.jpg";